export enum LogLevel {
    Critical,
    Error,
    Warning,
    Info,
    Debug,
    Verbose
}
